

























































































import { Component, Prop, Vue } from 'vue-property-decorator';

import VueDraggableResizable from 'vue-draggable-resizable';
import { getIdFromUrl, Youtube } from 'vue-youtube';

import CloseIcon from '@/components/icons/Close.vue';
import { IEducationPlayerProps } from './EducationPlayer';
import { sleep } from '@/utils';
import eventBus from '@/utils/eventBus';
import ArrowLinkUp from '@/components/icons/ArrowLinkUp.vue';
import segmentIo from '@/utils/segment.io';

@Component({
  components: {
    CloseIcon,
    VueDraggableResizable,
    Youtube,
    ArrowLinkUp
  }
})
export default class EducationPlayer extends Vue {
  $refs!: {
    youtube: HTMLFormElement;
  };
  @Prop() educationPlayerProps!: IEducationPlayerProps;

  dataResizable: any = {};

  timeout: any;

  allowShowHover = true;
  showHover = false;
  dragging = false;
  showExitNotification = false;
  triggerAnimation = false;
  showTitle = true;

  get tPrefix() {
    return 'common.educationPlayer';
  }

  get left() {
    if (this.educationPlayerProps.align === 'center') {
      return this.offset.left - this.width / 2 + 109 / 2;
    }

    return this.offset.left;
  }

  get leftStyle() {
    return this.left;
  }

  get topStyle() {
    if (this.$mobileCheck() && this.educationPlayerProps.align === 'right')
      return this.offset.top - 360;
    return this.offset.top;
  }

  get leftExitNotificationStyle() {
    if (this.$mobileCheck() && this.educationPlayerProps.align === 'right')
      return this.left - 170;
    return this.left;
  }

  get topExitNotificationStyle() {
    return this.offset.top;
  }

  get width() {
    if (this.$mobileCheck()) return this.showExitNotification ? 278 : 332;

    return this.showExitNotification ? 278 : 382;
  }

  get height() {
    let height = 302;
    if (this.educationPlayerProps.learnMoreLink) height = height + 56;

    if (this.$mobileCheck())
      return this.showExitNotification ? 64 : height - 70;

    return this.showExitNotification ? 64 : height;
  }

  get offset() {
    if (!this.educationPlayerProps.offset) return { left: 0, top: 0 };
    return this.educationPlayerProps.offset;
  }

  get videoId() {
    return getIdFromUrl(this.educationPlayerProps.link);
  }

  get youtubePlayer() {
    if (!this.$refs.youtube) return {};
    return this.$refs.youtube.player;
  }

  get x() {
    if (this.educationPlayerProps.align === 'center') return this.left;
    if (this.educationPlayerProps.align === 'left') return this.left;
    return this.left - this.width + 107;
  }

  onDrag() {
    clearTimeout(this.timeout);
    this.dragging = true;
    this.timeout = setTimeout(() => {
      this.dragging = false;
    }, 500);
  }

  onMouseEnter() {
    if (!this.allowShowHover || this.$mobileCheck()) return;
    this.showHover = true;
  }

  onClickPlay() {
    this.allowShowHover = false;
    this.showHover = false;
    this.onPlayVideo();
  }

  onPlayVideo() {
    this.youtubePlayer.playVideo();
  }

  onPauseVideo() {
    this.youtubePlayer.pauseVideo();
  }

  onLoad() {
    if (this.$mobileCheck()) return;

    this.onPlayVideo();
    setTimeout(() => {
      this.onPauseVideo();
    }, 300);
  }

  onPlaying() {
    if (!this.$mobileCheck()) return;

    this.showTitle = false;
  }

  async close() {
    this.showHover = false;
    this.triggerAnimation = true;
    await sleep(1000);

    this.showHover = false;
    this.showExitNotification = true;

    await sleep(3500);
    this.triggerAnimation = false;
    eventBus.$emit('closeEducationPlayer');
  }

  learnMoreClick() {
    if (this.educationPlayerProps.learnMoreClick)
      this.educationPlayerProps.learnMoreClick();
  }

  created() {
    if (this.educationPlayerProps.analyticsName)
      segmentIo.track(
        `Watched ${this.educationPlayerProps.analyticsName} Video`
      );
  }
}
